import { useTypedSelector } from '@Features/store';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { videoUnitGetSingle } from '../../Slices/Video.slice';
import EditVideoInfo from './Components/EditVideoInfo';
import { useUnitPermissions } from '@Pages/ClassRooms/Pages/SingleCourse/Pages/CourseForm/Pages/CourseContent/useUnitPermissions';

const EditVideo = () => {
	const { id } = useParams<{ id: string }>();
	const {
		currentEntity,
		loaders: { getSingle },
	} = useTypedSelector((state) => state.VideoUnit);
	const { canUpdate } = useUnitPermissions();
	const history = useHistory();

	const dispatch = useDispatch();

	useEffect(() => {
		if (!canUpdate) {
			history.goBack();
			return;
		}
		dispatch(
			videoUnitGetSingle({
				id: Number(id),
			})
		);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	if (!canUpdate) return null;

	return <>{currentEntity && getSingle === 'fulfilled' && <EditVideoInfo />}</>;
};

export default EditVideo;
